<div class="flex w-full items-center space-x-2">
  <svg
    aria-hidden="true"
    class="fill-negative-150"
    fill="currentColor"
    focusable="false"
    height="24"
    preserveAspectRatio="xMidYMid meet"
    viewBox="0 0 16 16"
    width="24"
    xmlns="http://www.w3.org/2000/svg">
    <path d="M8,1C4.1,1,1,4.1,1,8s3.1,7,7,7s7-3.1,7-7S11.9,1,8,1z M10.7,11.5L4.5,5.3l0.8-0.8l6.2,6.2L10.7,11.5z"></path>
    <path d="M10.7,11.5L4.5,5.3l0.8-0.8l6.2,6.2L10.7,11.5z" data-icon-path="inner-path" fill="none" opacity="0"></path>
  </svg>
  <div class="flex flex-row items-center text-sm text-negative-100">
    <ng-content></ng-content>
  </div>
</div>
